import { render, staticRenderFns } from "./editFiles.vue?vue&type=template&id=0d93b8dc"
import script from "./editFiles.vue?vue&type=script&lang=js"
export * from "./editFiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/Providers/editFiles.vue
// module id = 2484
// module chunks = 31